import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      marginTop: "10%",
      marginBottom: theme.spacing(8),

      [theme.breakpoints.down("xs")]: {
        marginLeft: 20,
        marginRight: 20,
      },
    },

    outerWrapper: {
      position: "relative",
    },

    outerWrapperInner: {
      margin: "0 20px",
    },

    contentWrapper: {
      position: "relative",
      boxShadow: theme.shadows[2],
      padding: "36px 36px 44px 36px",
      borderRadius: 2,
      backgroundColor: theme.palette.common.white,

      "& .title": {
        display: "block",
        fontSize: "1.1rem",
        fontWeight: theme.typography.fontWeightMedium,
        textAlign: "center",
      },

      "& .subTitle": {
        display: "block",
        fontSize: "0.8rem",
        fontWeight: theme.typography.fontWeightLight,
        textAlign: "center",
      },

      "& .errorWrapper": {
        display: "block",
        fontSize: "0.8rem",
        fontWeight: theme.typography.fontWeightLight,
        color: theme.palette.error.main,
      },
    },

    inputWrapper: {
      "& input": {
        textAlign: "center",
        fontSize: 14,
        fontWeight: theme.typography.fontWeightMedium,
        textTransform: "uppercase",
        paddingTop: 14,
      },
    },
  }),
  {
    name: "invitation-code-style",
    flip: null,
  }
);
